import { useRef } from 'react';
import { useSearchParams } from 'react-router';
import { useSetAtom } from 'jotai';
import { useFilterToUrlParser } from 'src/common/components/Filters/hooks/useFilterToUrlParser';
import { tariffSummaryUrlParamsAtom } from 'src/atoms/filters/tariff-summary';

export const TariffSummaryFiltersURLParser = ({ children }: { children: React.ReactElement }) => {
  const [searchParams] = useSearchParams();

  const setUrlsParams = useSetAtom(tariffSummaryUrlParamsAtom);
  const isMounted = useRef(false);

  useFilterToUrlParser(
    {
      urlSearchParamsAtom: tariffSummaryUrlParamsAtom,
    },
    isMounted.current,
  );

  if (!isMounted.current) {
    setUrlsParams(searchParams);
    isMounted.current = true;
  }

  return <>{children}</>;
};
